import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];

const NoPhotoCover = ({onScrollClick,details,showScrollIndicator,hideScrollIndicator}) => {
  
   const isLargeNameFont = LARGE_NAME_FONTS.includes(
  details?.nameFontStyle
);

  const groomNameBanner=()=>{
    return(<h3 
      className={`t2-cover-name ${
        isLargeNameFont ? "t2-cover-name--compact" : ""
      }`}
     style={{fontFamily:details.nameFontStyle}}>{ details?.groomName} </h3>)
  }

  const brideNameBanner=()=>{
     return(<h3 
         className={`t2-cover-name ${
        isLargeNameFont ? "t2-cover-name--compact" : ""
      }`}
     style={{fontFamily:details.nameFontStyle}}>{ details?.brideName} </h3>)
  }
  return (
    <section className='cover no-photo-cover cover-animate'>
      <img src="/theme2coverbg.jpg" alt="cover-img" className='t2-cover-bg-image' />
      <img src="/theme2coverAsset.png" alt="" srcset="" className='t2-frame-border t2-frame-border-top' />
      <img src="/theme2coverAsset.png" alt="" srcset="" className='t2-frame-border t2-frame-border-bottom' />

      <div className="t2-cover-details">
       <span className="t2-no-photo-cover-content">
  We are honored to welcome you to the {details?.functionType || "wedding"} ceremony of
</span>
        {/* <span className="t2-no-photo-cover-content">
         {details?.userCode === "kb9k492tk"
    ? "We are honoured to welcome you to the engagement ceremony of"
    : "We are honoured to welcome you to the wedding ceremony of"}
        </span> */}
         <div className="t2-cover-name-wrapper">
         
         {details?.displayOrder==="groomFirst"?<>
               {groomNameBanner()}
              <span 
                 className={`t2-cover-and ${
        isLargeNameFont ? "t2-cover-and--compact" : ""
      }`}
              
              style={{fontFamily:details.nameFontStyle}}>&</span>
              {brideNameBanner()}
         </>:<>
                {brideNameBanner()}
              <span 
                 className={`t2-cover-and ${
        isLargeNameFont ? "t2-cover-and--compact" : ""
      }`}
              
              style={{fontFamily:details.nameFontStyle}}>&</span>
                 {groomNameBanner()} 
         </>}
         </div>
    
                   {details?.hashtag && (
    <div className="t2-cover-hashtag">#{details.hashtag}</div>
)}
        
      </div>
        {showScrollIndicator && (<div  className={`t2-scroll-indicator ${ hideScrollIndicator ? "hide" : ""}`} onClick={onScrollClick}>
                      <ExpandMoreIcon className='t2-scroll-indication-icon' />
                    <span>SCROLL</span>
                  </div>) }
    </section>
  )
}

export default NoPhotoCover

